import { type Theme } from "@mui/material";
import { type TierType } from "@src/appV2/redesign/Tiers/api/schema";

// No default clause or consistent return as it should be exhaustive
// eslint-disable-next-line consistent-return
export function getTextColorForTier(tier: TierType, theme: Theme) {
  // eslint-disable-next-line default-case
  switch (tier) {
    case "GOLD": {
      return theme.palette.tiers?.gold.text;
    }

    case "SILVER": {
      return theme.palette.tiers?.silver.text;
    }

    case "LIMITED": {
      return theme.palette.tiers?.limited.text;
    }
  }
}
